/**
 * callbackUrl이 상대경로(서비스 내부 경로)인지 검증합니다.
 * 외부 도메인으로의 리다이렉트를 방지하기 위해 사용됩니다.
 *
 * @param callbackUrl - 검증할 URL
 * @returns 상대경로인 경우 true, 그 외의 경우 false
 *
 * @example
 * validateCallbackUrl('/clobe/home') // true
 * validateCallbackUrl('/auth/join-by-invitation?token=xxx') // true
 * validateCallbackUrl('https://evil.com') // false
 * validateCallbackUrl('//evil.com') // false
 * validateCallbackUrl('http://evil.com') // false
 */
export function validateCallbackUrl(callbackUrl: string | undefined | null): boolean {
  if (!callbackUrl) {
    return true; // 빈 값은 허용 (기본값 사용)
  }

  // 상대경로는 '/'로 시작해야 함
  if (!callbackUrl.startsWith('/')) {
    return false;
  }

  // 프로토콜이 포함된 URL 차단 (http://, https://, // 등)
  if (/^https?:\/\//i.test(callbackUrl) || callbackUrl.startsWith('//')) {
    return false;
  }

  // 추가 보안: javascript:, data: 등의 프로토콜 차단
  if (/^[a-z]+:/i.test(callbackUrl)) {
    return false;
  }

  return true;
}

/**
 * callbackUrl을 검증하고, 유효하지 않은 경우 기본값을 반환합니다.
 *
 * @param callbackUrl - 검증할 URL
 * @param fallbackUrl - 유효하지 않은 경우 사용할 기본 URL
 * @returns 검증된 URL 또는 기본 URL
 */
export function sanitizeCallbackUrl(
  callbackUrl: string | undefined | null,
  fallbackUrl: string,
): string {
  if (validateCallbackUrl(callbackUrl)) {
    return callbackUrl || fallbackUrl;
  }
  return fallbackUrl;
}
